import { ScriptDef, ScriptTheme } from '../../types';

export const MOVIE_XIANSHI_SCRIPTS: ScriptDef[] = [
    {
        id: 'SCRIPT_153',  // 电影/现实题材社会讽刺伦理·版本一
        name: '顶岗',
        genre: 'movie',
        synopsis: '职业技术学校机电系全班被派往电子厂顶岗实习，专业不对口，不去不发毕业证。学生唐荞在流水线一天站十二个小时，室友雷响三次出逃两次被抓回，带班师傅闵来喜看在眼里。订单激增后宿舍熄灯一再推迟，学生与厂方、学校的矛盾逐渐激化。',
        roles: [
            {
                name: '唐荞',
                roleType: '女主角',
                billing: 1,
                intro: '职校学生，中考差几分没上普高。工位记录本记满不合格品的缺陷，翻到背面全是宿舍里写的请假条底稿。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '雷响',
                roleType: '男配角',
                billing: 2,
                intro: '唐荞室友，出逃过又被抓回来过，手机被统一保管。行李一直收拾得随时能背走。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '闵来喜',
                roleType: '男配角',
                billing: 2,
                intro: '产线带班师傅，厂龄十一年，带过好几批学生工。教徒弟只有一句"手别抖"。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.SeriousDrama, ScriptTheme.LifeStyle],
        heat: 48,
        baseScore: 8.4,
    },
    {
        id: 'SCRIPT_154',  // 电影/乡土底层现实主义·版本一
        name: '门牌',
        genre: 'movie',
        synopsis: '黄河滩区迁建，整村搬进新社区。老门牌匠苗有根挨家起下自己挂上去的搪瓷门牌；裁缝岑厚土的铺子里寄存着全村的寿衣，搬不走也丢不下；吊车司机解河生负责把村口那棵几百年的老槐树移进新社区广场。最后树落进树坑，门牌一栋楼一栋楼挂上了新墙。',
        roles: [
            {
                name: '解河生',
                roleType: '男二号',
                billing: 2,
                intro: '吊车司机，吊过楼板吊过牲口，没吊过活树。给老槐树断根那天，他熄了火等麻雀回巢。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'stamina', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, stamina: 2 },
            },
            {
                name: '沈雁洲',
                roleType: '女配角',
                billing: 3,
                intro: '迁建办干部，文件念得字正腔圆，鞋越走越旧。放行条被退，她干脆坐进押运车签责任。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '郑麦穗',
                roleType: '女配角',
                billing: 5,
                intro: '滩区迁建村的高二学生，把自家门牌号默写在草稿纸抬头，描了一遍又一遍。搬进新社区那天，她把旧牌子要了回去，钉在自家楼道口。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.LifeStyle, ScriptTheme.SeriousDrama],
        heat: 48,
        baseScore: 8.5,
    },
    {
        id: 'SCRIPT_155',  // 电影/乡土底层现实主义·版本二
        name: '响器',
        genre: 'movie',
        synopsis: '晋北鼓匠班班主米震天带班在红白事间讨生活，徒弟付来宝学艺未成，镇上又来了报价减半的电子琴婚庆乐队，琴凳上坐着镇中学的音乐代课老师柳铃，拉线接电的是电工家的儿子吕坡。一场大办的白事上，主家把两拨人都请了场。米震天不降价，把师父口传的无名老调，吹给了满场的人。',
        roles: [
            {
                name: '付来宝',
                roleType: '男二号',
                billing: 2,
                intro: '学徒，城郊长大，本想学电子琴。偷录了师父所有老调，手机被雨淋了，他捧着走了一路。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'artistry', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, artistry: 2, charm: 2 },
            },
            {
                name: '齐守孝',
                roleType: '男配角',
                billing: 3,
                intro: '白事主家，跑运输的，父亲走得急。出殡那天早上，他把乐队和鼓匠班都请了，自己站中间听完。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '柳铃',
                roleType: '女配角',
                billing: 4,
                intro: '镇中学的音乐代课老师，晚上跟电子琴班子走穴挣课时费。那晚两拨人同场，她在琴凳上坐到散场，一个键没按；第二天把乐队的报价单撕了。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'artistry', value: 18 },
                    { attr: 'temperament', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { artistry: 2, temperament: 2 },
            },
            {
                name: '吕坡',
                roleType: '男配角',
                billing: 5,
                intro: '电工家的儿子，十六岁就跟着乐队跑场子拉线接电，一箱电缆一个人扛。就是他把插排从电子琴那边挪到了鼓匠班的喇叭底下，谁也没叫停。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'stamina', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { stamina: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.LifeStyle, ScriptTheme.Music],
        heat: 50,
        baseScore: 8.3,
    },
];
